import { MouseEvent, useEffect, useRef, useState } from 'react'

export const useCarousel = <T extends HTMLDivElement>() => {
  const ref = useRef<T | null>(null)
  const [atStart, setAtStart] = useState(true)
  const [atEnd, setAtEnd] = useState(false)

  useEffect(() => {
    const el = ref.current

    if (!el) return

    const updateEdges = () => {
      const { scrollLeft, scrollWidth, clientWidth } = el

      setAtStart(scrollLeft <= 0)
      setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1)
    }

    updateEdges()
    el.addEventListener('scroll', updateEdges, { passive: true })
    window.addEventListener('resize', updateEdges)

    return () => {
      el.removeEventListener('scroll', updateEdges)
      window.removeEventListener('resize', updateEdges)
    }
  }, [])

  const scrollForward = (e: MouseEvent) => {
    e.preventDefault()

    const el = ref.current

    if (!el) return

    el.scrollBy({ left: el.clientWidth / 1.35, behavior: 'smooth' })
  }

  const scrollBack = (e: MouseEvent) => {
    e.preventDefault()

    const el = ref.current

    if (!el) return

    el.scrollBy({ left: -el.clientWidth / 1.35, behavior: 'smooth' })
  }

  return { ref, atStart, atEnd, scrollForward, scrollBack }
}
